import { doc, setDoc } from "firebase/firestore"; 
import { firestore } from "./config";

export const updateContentHarvestStep = async (winegrower, data) => {
    const docRef = doc(firestore, `winegrowers/${winegrower}/customSteps/harvestStep`);
    return await setDoc(docRef, data);
};
